//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// custom pages
import config from "config/index";
import HandleApiResponse from "helpers/handleApiResponse";

const auditTierApi = () => {
  const { handleResponse, handleError } = HandleApiResponse();

  async function uploadAuditTier(values) {
    try {
      const requestPayload = {
        method: "POST",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
        body: JSON.stringify(values),
      };
      let res = await fetch(
        `${config.host}/cdr-panel/loyalty/upload-audit-tier`,
        requestPayload
      );
      return handleResponse(res);
    } 
    catch (err) {
      handleError(err);
    }
  }

  async function uploadDriveToThrive(values) {
    try {
      const requestPayload = {
        method: "POST",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
        body: JSON.stringify(values),
      };
      let res = await fetch(
        `${config.host}/cdr-panel/loyalty/upload-drive-to-thrive`,
        requestPayload
      );
      return handleResponse(res);
    } 
    catch (err) {
      handleError(err);
    }
  }

  async function generateCsvFile() {
    try {
      const requestPayload = {
        method: "GET",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        }
      };
      let res = await fetch(
        `${config.host}/cdr-panel/loyalty/generate-csv`,
        requestPayload
      );
      return handleResponse(res);
    } 
    catch (err) {
      handleError(err);
    }
  }

  async function uploadDormant(values) {
    try {
      const requestPayload = {
        method: "POST",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
        body: JSON.stringify(values),
      };
      let res = await fetch(
        `${config.host}/cdr-panel/dormant-automation/upload-dormant`,
        requestPayload
      );
      return handleResponse(res);
    } 
    catch (err) {
      handleError(err);
    }
  }
  async function uploadDormantcancel() {
    try {
      const requestPayload = {
        method: "POST",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
       
      };
      let res = await fetch(
        `${config.host}/cdr-panel/dormant-automation/cancel-dormant`,
        requestPayload
      );
      return handleResponse(res);
    } 
    catch (err) {
      handleError(err);
    }
  }
  async function uploadDormantexecute(values) {
    try {
      const requestPayload = {
        method: "POST",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
        body: JSON.stringify(values),
       
      };
      let res = await fetch(
        `${config.host}/cdr-panel/dormant-automation/execute-dormant`,
        requestPayload
      );
      return handleResponse(res);
    } 
    catch (err) {
      handleError(err);
    }
  }

  return {
    uploadAuditTier,
    uploadDriveToThrive,
    generateCsvFile,
    uploadDormant,
    uploadDormantcancel,
    uploadDormantexecute
  };
};
export default auditTierApi;
